module.exports = __webpack_public_path__ + "static/media/sopt13kz.46cc3faf.pdf";